import { getHtmlRequest } from "../utils/fetch";

const basePath = `/apicore/authenticationapi/`;
export function getToken(): Promise<string> {
	return getHtmlRequest(basePath + "authenticationtoken");
}
